var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "page-tab member-logs-v2",
      staticStyle: { height: "540px" },
    },
    [
      _c("SchemaTablePage", {
        ref: "tablePageRef",
        attrs: {
          "form-props": { labelPosition: "left" },
          "layout-mode": "dialog",
          immediate: false,
          "search-schema": _vm.searchSchema,
          columns: _vm.tableColumns,
          "default-query": _vm.defaultQuery,
          request: _vm.request,
          "build-params": _vm.buildParams,
          "parse-result": _vm.parseResult,
        },
        scopedSlots: _vm._u([
          {
            key: "search-module",
            fn: function ({ query }) {
              return [
                _c("el-cascader", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    options: _vm.moduleOptions,
                    placeholder: "选择操作菜单",
                    clearable: "",
                    filterable: "",
                    separator: "-",
                  },
                  on: {
                    change: (values) =>
                      (query.module = values?.length ? values.join("-") : ""),
                  },
                  model: {
                    value: query.modulePath,
                    callback: function ($$v) {
                      _vm.$set(query, "modulePath", $$v)
                    },
                    expression: "query.modulePath",
                  },
                }),
              ]
            },
          },
          {
            key: "createdAt",
            fn: function ({ row }) {
              return [_vm._v(_vm._s(_vm._f("formatTimestamp")(row.created_at)))]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }